/* eslint-disable react/jsx-props-no-spreading */
import { ArrowDown } from './icons/ui';

const Select = props => {
  const { children, className = '', ...inputProps } = props;

  return (
    <div className={`input relative w-full ${className}`}>
      <span className="">&nbsp;</span>
      <div className="absolute top-0 right-0 flex h-full items-center pr-4">
        <ArrowDown className="h-3 w-3" />
      </div>
      <select
        {...inputProps}
        className="absolute top-0 left-0 h-full w-full appearance-none border-0 bg-transparent px-[18px] py-[16px] pr-5"
        style={{ textTransform: 'inherit' }}
      >
        {children}
      </select>
    </div>
  );
};

export default Select;
